import * as React from "react";
import { Path, UseFormRegisterReturn } from "react-hook-form";
import { FormTypes } from "src/components/shared/FormTypes";
import InputWrapper from "../InputWrapper/InputWrapper";
import { StyledInput } from "../TextInput/TextInput.components";

interface Props {
  aria: string;
  name?: string;
  type?: string;
  value?: string | number;
  errorMessage?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>;
  placeholder?: string;
  label: Path<FormTypes>;
  register?: UseFormRegisterReturn;
  pattern?: string;
}

const TextInput: React.FunctionComponent<Props> = ({
  aria,
  label,
  name,
  type = "text",
  value,
  errorMessage,
  onChange,
  placeholder,
  register,
  ...rest
}) => (
  <InputWrapper
    withPlaceholder={!!placeholder}
    label={label}
    name={name}
    errorMessage={errorMessage}>
    <StyledInput
      placeholder={placeholder}
      onChange={onChange}
      aria-label={aria}
      type={type}
      value={value}
      name={name}
      id={name}
      autoComplete="off"
      {...(register && register)}
      {...rest}
    />
  </InputWrapper>
);

export default TextInput;
